const styles = theme => ({
  root: {
    background: '#004f9e',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  title: {
    color: '#FFCA00',
    fontSize: '32px',
    lineHeight: '48px',
    fontWeight: '300',
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    color: '#fff',
    fontSize: '24px',
    lineHeight: '36px',
    fontWeight: '300',
  },
  button: {
    padding: theme.spacing(1, 8),
    marginTop: theme.spacing(4),
    background: '#00A8E9',
    fontSize: '14px',
    '&:hover': {
      background: '#0087bd',
    },
  },
  iconButton: {
    marginLeft: theme.spacing(1),
  },
  iconBackButton: {
    marginRight: theme.spacing(1),
  },
  img: {
    marginLeft: theme.spacing(16),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(0),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
})

export default styles
